import React from "react";
import { Card, Button, CardBody } from "reactstrap";
import { File } from "react-feather";
import ShowMoreText from "react-show-more-text";
import { parseJSON, formatDistance, format } from "date-fns";
import { sentence } from "case";

import { Document } from "../../api";

interface Props extends Document { }

const DocumentCard = (props: Props) => {
  const now = new Date();
  const created = props.created ? parseJSON(props.created) : void 0;
  return (
    <Card>
      <CardBody className="d-flex flex-column justify-content-between">
        <div>
          <div className="d-flex align-items-center">
            <div className="mr-3"><File /></div>
            <div className="h5  mb-0">{props.title}</div>
          </div>
          <div className="d-flex justify-content-between mt-2 fs-10">
            {!!created && (
              <span title={format(created, "PPPp")}>{sentence(formatDistance(created, now, { addSuffix: true }))}</span>)}
            <span>{props.size}</span>
          </div>
          {!!props.description &&
            <ShowMoreText
              lines={3}
              more="Show more"
              less="Show less"
              expanded={false}
              anchorClass="text-primary"
              className="mt-3">
              {props.description}
            </ShowMoreText>}
        </div>
        <div className="mt-4">
          <Button
            color="primary"
            className="mt-4 revert btn-sm my-2 w-100"
            href={props.downloadUrl}
            download
          >
            Download
            </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default DocumentCard;
